import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

const appName = "@@stakeholderAlignment/"

const loadAlignmentTypesObjs = makePieActionObjs("load", "alignmentTypes")
export const loadAlignmentTypesActionDict = prependAppName(appName, loadAlignmentTypesObjs.pieDict)

const loadAlignmentTypeObjs = makePieActionObjs("load", "alignmentType")
export const loadAlignmentTypeActionDict = prependAppName(appName, loadAlignmentTypeObjs.pieDict)

const updateAlignmentTypeObjs = makePieActionObjs("update", "alignmentType")
export const updateAlignmentTypeActionDict = prependAppName(appName, updateAlignmentTypeObjs.pieDict)

const loadProfileAlignmentObjs = makePieActionObjs("load", "profileAlignment")
export const loadProfileAlignmentActionDict = prependAppName(appName, loadProfileAlignmentObjs.pieDict)

const loadIssueAlignmentsObjs = makePieActionObjs("load", "issueAlignments")
export const loadIssueAlignmentsActionDict = prependAppName(appName, loadIssueAlignmentsObjs.pieDict)

const postProfileAlignmentObjs = makePieActionObjs("post", "profileAlignment")
export const postProfileAlignmentActionDict = prependAppName(appName, postProfileAlignmentObjs.pieDict)

const postIssueAlignmentObjs = makePieActionObjs("post", "issueAlignment")
export const postIssueAlignmentActionDict = prependAppName(appName, postIssueAlignmentObjs.pieDict)

const removeProfileAlignmentObjs = makePieActionObjs("remove", "profileAlignment")
export const removeProfileAlignmentActionDict = prependAppName(appName, removeProfileAlignmentObjs.pieDict)

const removeIssueAlignmentObjs = makePieActionObjs("remove", "issueAlignment")
export const removeIssueAlignmentActionDict = prependAppName(appName, removeIssueAlignmentObjs.pieDict)

export default prependAppName(
    appName,
    {
        ...loadAlignmentTypesObjs.actionTypes,
        ...loadAlignmentTypeObjs.actionTypes,
        ...updateAlignmentTypeObjs.actionTypes,
        ...loadProfileAlignmentObjs.actionTypes,
        ...loadIssueAlignmentsObjs.actionTypes,
        ...postProfileAlignmentObjs.actionTypes,
        ...postIssueAlignmentObjs.actionTypes,
        ...removeProfileAlignmentObjs.actionTypes,
        ...removeIssueAlignmentObjs.actionTypes,
    }
)
